import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Autoplay from 'embla-carousel-autoplay';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import { Button } from '@/components/ui/button';

export const AnimeFandomCarousel = () => {
  const plugin = React.useRef(
    Autoplay({ delay: 2000, stopOnInteraction: false })
  );

  // [NEW] State to track the carousel API and current slide index
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);

  // [NEW] Effect to sync state with carousel events
  useEffect(() => {
    if (!api) {
      return;
    }

    // Set initial state
    setCurrent(api.selectedScrollSnap());

    // Update state on slide change
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);

  const slides = [
    {
      image: 'https://wallpapercave.com/wp/wp7554510.jpg',
      title: 'One Piece',
      subtitle: 'Join the Straw Hat Pirates!',
      cta: 'Explore',
      link: '/products?search=one%20piece',
    },
    {
      image: 'https://images.hdqwalls.com/wallpapers/jujutsu-kaisen-sengaku-soran-4k-wz.jpg',
      title: 'Jujutsu Kaisen',
      subtitle: 'Unleash Your Cursed Energy',
      cta: 'Discover',
      link: '/products?search=jujutsu',
    },
    {
      image: 'https://wallpaperaccess.com/full/1099445.png',
      title: 'Demon Slayer',
      subtitle: 'Slay the Demons',
      cta: 'Shop Now',
      link: '/products?search=demon',
    },
  ];

  return (
    <div className="w-full" data-testid="anime-fandom-carousel">
      <Carousel
        plugins={[plugin.current]}
        setApi={setApi}
        className="w-full"
        opts={{
          loop: true,
        }}
      >
        <CarouselContent>
          {slides.map((slide, index) => (
            <CarouselItem key={index}>
              <div className="relative h-[300px] md:h-[400px] overflow-hidden rounded-3xl">
                <img
                  src={slide.image}
                  alt={slide.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent flex items-center">
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                    <div className="max-w-xl space-y-2">
                      <h2 className="font-outfit font-bold text-3xl md:text-5xl text-white tracking-tight">
                        {slide.title}
                      </h2>
                      <p className="text-lg md:text-xl text-white/90">
                        {slide.subtitle}
                      </p>
                      <Link to={slide.link}>
                        <Button
                          className="rounded-full px-6 py-4 bg-primary text-primary-foreground hover:bg-primary/90 font-bold"
                          data-testid={`anime-cta-${index}`}
                        >
                          {slide.cta}
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      <div className="absolute bottom-6 left-0 right-0 flex justify-center gap-2 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => api?.scrollTo(index)}
            aria-label={`Go to slide ${index + 1}`}
            className={`transition-all duration-300 rounded-full ${current === index
                ? "bg-white w-8 h-2"  // Active dot: wider and white
                : "bg-white/50 w-2 h-2 hover:bg-white/75" // Inactive dot: small circle and transparent
              }`}
          />
        ))}
      </div>
      </Carousel>
    </div>
  );
};
